import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  Tooltip,
} from '@chakra-ui/react';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../core/hooks/storeHooks';

const MasterTabConflictDialog: React.FC = () => {
  const contineuRef = useRef(null);
  const { t } = useTranslation();

  const userName = useAppSelector((state) => state.auth.user.fullname);

  const reloadTab = () => window.location.reload();

  const openNewTab = () => {
    const currentURL = window.location.href;
    window.open(currentURL, '_blank');
  };

  return (
    <AlertDialog
      isOpen={true}
      leastDestructiveRef={contineuRef}
      onClose={() => {}}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {t('permission.masterTab.title')}
          </AlertDialogHeader>

          <AlertDialogBody>
            {t('permission.masterTab.description', { userName })}
          </AlertDialogBody>

          <AlertDialogFooter>
            <Tooltip
              key={'reload'}
              label={t('permission.masterTab.reloadNote')}
              p={3}
              borderRadius={10}
              hasArrow={true}
            >
              <Button colorScheme="red" onClick={reloadTab}>
                {t('permission.masterTab.reload')}
              </Button>
            </Tooltip>

            <Button
              ref={contineuRef}
              colorScheme="green"
              onClick={openNewTab}
              ml={3}
            >
              {t('permission.masterTab.openNewTab')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default MasterTabConflictDialog;
